export default {"src":"/_next/static/media/standartType2.1db3ed9b.svg","height":21,"width":18,"blurWidth":0,"blurHeight":0};